import React, { useEffect, useRef, useState } from "react";
import ProfileSidebar from "../common/ProfileSidebar";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import axiosClient from "../../Services/Axios/axios";
import Swal from "sweetalert2";
import { ClipLoader } from "react-spinners";
import SellerSidebar from "../../SellerDashboardPages/common/SellerSidebar";

const AddCampaign = () => {
  const [formState, setFormState] = useState({
    donation_title: "",
    global_amount: "",
    donation_description: "",
    donation_category_id: "",
    donation_images: "",
    expiry_date: new Date(),
    other_images: [""],
    documents: [""],
  });
  const [categoryData, setCategoryData] = useState([]);

  const [documentUploadStatus, setDocumentUploadStatus] = useState(
    formState.documents.map(() => ({ uploading: false, successMessage: "" }))
  );
  const [galleryUploadStatus, setGalleryUploadStatus] = useState(
    formState.other_images.map(() => ({ uploading: false, successMessage: "" }))
  );
  const [coverImageUploadStatus, setCoverImageUploadStatus] = useState({
    uploading: false,
    successMessage: "",
  });
  const [buttonloader, setButtonloader] = useState(false);
  const [errors, setErrors] = useState({});
  const [image, setImage] = useState(null);
  const fileInputRef = useRef();
  const datepickerRef = useRef(null);
  const navigate = useNavigate();
  const validate = () => {
    const newErrors = {};
    if (!formState.donation_title.trim())
      newErrors.donation_title = "Title is required.";
    if (!formState.global_amount.trim() || isNaN(formState.global_amount))
      newErrors.global_amount = "Valid amount is required.";
    else if (parseFloat(formState.global_amount) > 99999999.99)
      newErrors.global_amount = "Amount must not exceed 99999999.99.";
    if (!formState.donation_description.trim())
      newErrors.donation_description = "Description is required.";
    if (!formState.donation_category_id)
      newErrors.donation_category_id = "Category is required.";
    if (!formState.donation_images)
      newErrors.donation_images = "Cover image is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e, index, type) => {
    const { name, value, files } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); /*add by me */
    setFormState({ ...formState, [name]: files ? files[0] : value });
  };

  const addMoreFields = (type) => {
    if (type === "gallery") {
      if (formState.other_images.length >= 10) {
        Swal.fire({
          icon: "warning",
          title: "Limit Reached",
          text: "You can only upload a maximum of 10 gallery images.",
        });
        return;
      }

      setFormState({
        ...formState,
        other_images: [...formState.other_images, ""],
      });
      setGalleryUploadStatus((prev) => [
        ...prev,
        { uploading: false, successMessage: "" },
      ]);
    } else if (type === "documents") {
      if (formState.documents.length >= 10) {
        Swal.fire({
          icon: "warning",
          title: "Limit Reached",
          text: "You can only upload a maximum of 10 documents.",
        });
        return;
      }
      setFormState({ ...formState, documents: [...formState.documents, ""] });
      setDocumentUploadStatus((prev) => [
        /*by me*/ ...prev,
        { uploading: false, successMessage: "" },
      ]);
    }
  };

  const removeField = (index, type) => {
    if (type === "gallery") {
      const updatedImages = formState.other_images.filter(
        (_, i) => i !== index
      );
      setFormState({ ...formState, other_images: updatedImages });
      setGalleryUploadStatus((prev) => prev.filter((_, i) => i !== index));
    } else if (type === "documents") {
      const updatedDocuments = formState.documents.filter(
        (_, i) => i !== index
      );
      setFormState({ ...formState, documents: updatedDocuments });
      setDocumentUploadStatus((prev) =>
        prev.filter((_, i) => i !== index)
      ); /*by me*/
    }
  };

  const handleChange1 = async (e, index, type) => {
    try {
      const file = e.target.files[0];
      setErrors((prevErrors) => ({ ...prevErrors, donation_images: "" }));

      if (!file) return;

      // Allowed file types
      const imageTypes = ["image/jpeg", "image/jpg", "image/png"];
      const documentTypes = ["application/pdf"];

      const maxSizeInBytes = parseInt(
        process.env.REACT_APP_MAX_FILE_SIZE_MB,
        10
      );

      let formData = new FormData();
      let uploadUrl = "";
      let appendKey = "";

      // Image dimension validation function
      const validateImageDimensions = (file) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            if (img.width === 790 && img.height === 475) {
              resolve(true);
            } else {
              reject("Error: Image dimensions must be 790x475 pixels.");
            }
          };
          img.onerror = () => reject("Invalid image file.");
          img.src = URL.createObjectURL(file);
        });
      };

      // Validation & API Endpoint Selection
      if (type === "gallery") {
        if (!imageTypes.includes(file.type)) {
          setGalleryUploadStatus((prev) =>
            prev.map((status, i) =>
              i === index
                ? {
                    uploading: true,
                    successMessage: "",
                  }
                : status
            )
          );
          setTimeout(() => {
            setGalleryUploadStatus((prev) =>
              prev.map((status, i) =>
                i === index ? { ...status, uploading: false } : status
              )
            );
            Swal.fire({
              icon: "error",
              title: "Only images (JPG, JPEG, PNG) are allowed in the gallery",
            });
          }, 2000);
          e.target.value = "";
          return;
        }
        try {
          await validateImageDimensions(file); // Validate image dimensions
        } catch (error) {
          setGalleryUploadStatus((prev) =>
            prev.map((status, i) =>
              i === index
                ? {
                    uploading: true,
                    successMessage: "",
                  }
                : status
            )
          );
          setTimeout(() => {
            setGalleryUploadStatus((prev) =>
              prev.map((status, i) =>
                i === index ? { ...status, uploading: false } : status
              )
            );
            Swal.fire({
              icon: "error",
              title: "Invalid Image Dimensions",
              text: error,
            });
          }, 2000);

          e.target.value = null;
          return;
        }
        appendKey = "image";
        uploadUrl = "/users/uploadimg";
        // setGalleryUploadStatus((prev) =>
        //   prev.map((status, i) =>
        //     i === index ? { ...status, uploading: true } : status
        //   )
        // );
      } else if (type === "documents") {
        if (!documentTypes.includes(file.type)) {
          setDocumentUploadStatus((prev) =>
            prev.map((status, i) =>
              i === index
                ? {
                    uploading: true,
                    successMessage: "",
                  }
                : status
            )
          );
          setTimeout(() => {
            setDocumentUploadStatus((prev) =>
              prev.map((status, i) =>
                i === index
                  ? {
                      uploading: false,
                      successMessage: "",
                    }
                  : status
              )
            );

            Swal.fire({
              icon: "error",
              title: "Invalid File Type",
              text: "Only PDF files are allowed.",
            });
          }, 2000);
          e.target.value = "";
          return;
        }
        if (file.size > maxSizeInBytes) {
          setDocumentUploadStatus((prev) =>
            prev.map((status, i) =>
              i === index
                ? {
                    uploading: true,
                    successMessage: "",
                  }
                : status
            )
          );
          setTimeout(() => {
            setDocumentUploadStatus((prev) =>
              prev.map((status, i) =>
                i === index
                  ? {
                      uploading: false,
                      successMessage: "",
                    }
                  : status
              )
            );
            Swal.fire({
              icon: "error",
              title: "File Size Exceeded",
              text: `File size must be less than 5 MB.`,
            });
          }, 2000);
          e.target.value = "";

          return;
        }
        appendKey = "pdf";
        uploadUrl = "/users/uploadpdf";
      } else if (type === "donation_images") {
        if (!imageTypes.includes(file.type)) {
          Swal.fire({
            icon: "error",
            title: "Only images (JPG, JPEG, PNG) are allowed in the gallery",
          });
          e.target.value = "";
          return;
        }
        try {
          await validateImageDimensions(file);
        } catch (error) {
          setCoverImageUploadStatus({ uploading: true, successMessage: "" });
          setTimeout(() => {
            setCoverImageUploadStatus({ uploading: false, successMessage: "" });
            Swal.fire({
              icon: "error",
              title: "Invalid Image Dimensions",
              text: error,
            });
          }, 2000);

          e.target.value = null;
          return;
        }
        setCoverImageUploadStatus({ uploading: true, successMessage: "" });
        appendKey = "image";
        uploadUrl = "/users/uploadimg";
      }
      if (type === "documents") {
        setDocumentUploadStatus((prev) =>
          prev.map((status, i) =>
            i === index ? { ...status, uploading: true } : status
          )
        );
      }
      if (type === "gallery") {
        setGalleryUploadStatus((prev) =>
          prev.map((status, i) =>
            i === index ? { ...status, uploading: true } : status
          )
        );
      }
      // Upload logic
      formData.append(appendKey, file);
      const responce = await axiosClient.post(uploadUrl, formData);
      if (type === "gallery") {
        setGalleryUploadStatus((prev) =>
          prev.map((status, i) => (i === index ? { uploading: false } : status))
        );
      }

      setDocumentUploadStatus((prev) =>
        prev.map((status, i) =>
          i === index ? { ...status, uploading: false } : status
        )
      );
      if (!responce.data.error) {
        if (type === "gallery") {
          const updatedImages = [...formState.other_images];
          updatedImages[index] = responce.data.file;
          setFormState({ ...formState, other_images: updatedImages });
          setGalleryUploadStatus((prev) =>
            prev.map((status, i) =>
              i === index
                ? {
                    ...status,
                    successMessage: "Document uploaded successfully!",
                  }
                : status
            )
          );

          return;
        } else if (type === "documents") {
          const updatedDocuments = [...formState.documents];
          updatedDocuments[index] = responce.data.file;
          setFormState({ ...formState, documents: updatedDocuments });
          setDocumentUploadStatus((prev) =>
            prev.map((status, i) =>
              i === index
                ? {
                    ...status,
                    successMessage: "Document uploaded successfully!",
                  }
                : status
            )
          );
          return;
        } else if (type === "donation_images") {
          setFormState({ ...formState, donation_images: responce.data.file });
          setCoverImageUploadStatus({
            uploading: false,
            successMessage: "Cover image uploaded successfully!",
          });
          return;
        }
      }

      // Show preview for images only
      if (imageTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onload = () => {
          setImage(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "File is too large or an unexpected error occurred.",
      });
      e.target.value = null; // Reset file input on error
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (validate()) {
        setButtonloader(true);
        const data = await axiosClient.post(
          `/campaigns/${process.env.REACT_APP_API_VERSION}/add-campaign`,
          formState
        );
        if (!data.data.error) {
          Swal.fire({
            icon: "success",
            title: data.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
        setFormState({
          ...formState,
          donation_title: "",
          global_amount: "",
          donation_description: "",
          donation_category_id: "",
          donation_images: "",
          expiry_date: new Date(),
          other_images: [""],
          documents: [""],
        });
        navigate("/manage-campaign");
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; // Clearing the file input
        }
        setButtonloader(false);
      }
    } catch (error) {
      console.log(error);
      setButtonloader(false);
      Swal.fire({
        icon: "error",
        title: error.response.data.message,
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };
  const getAllData = async () => {
    try {
      const category = await axiosClient.get(
        `/campaigns/getCampaignsCategory?language=en`
      );
      if (!category.data.error) {
        setCategoryData(
          category.data.data.map((item) => {
            return {
              label: item.category_name,
              value: item.id,
            };
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setFormState({
      ...formState,
      donation_category_id: categoryData[0]?.value,
      organization_id: Number(sessionStorage.getItem("organization_id")),
    });
  }, [categoryData]);

  useEffect(() => {
    getAllData();
  }, []);
  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea evnetsts profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="/profile">Dashboard</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" />{" "}
                <Link to="/campaign">Campaigns</Link>
                <img src="/images/brd_rowwo.png" alt="" />{" "}
                <Link to="/add-campaign">Add Campaigns</Link>
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>
              <div className="col-lg-9">
                <div className="form_boxx profilss">
                  <h4 className="br_space">Add Campaign</h4>
                  <div className="form_arar mt-0">
                    <div className="mang_und_listst mt-0">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>Title</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="donation_title"
                                    placeholder="Enter title"
                                    value={formState.donation_title}
                                    onChange={handleChange}
                                    maxLength={60}
                                    onKeyPress={(e) => {
                                      if (!/[a-zA-Z\s]/.test(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                  {errors.donation_title && (
                                    <small className="text-danger">
                                      {errors.donation_title}
                                    </small>
                                  )}
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>About Campaign</label>
                                  <textarea
                                    className="form-control"
                                    rows="4"
                                    name="donation_description"
                                    placeholder=""
                                    value={formState.donation_description}
                                    onChange={handleChange}
                                  ></textarea>
                                  {errors.donation_description && (
                                    <small className="text-danger">
                                      {errors.donation_description}
                                    </small>
                                  )}
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label>Amount</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="global_amount"
                                    placeholder="Enter amount"
                                    value={formState.global_amount}
                                    onChange={handleChange}
                                  />
                                  {errors.global_amount && (
                                    <small className="text-danger">
                                      {errors.global_amount}
                                    </small>
                                  )}
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label>Category</label>
                                  <select
                                    className="form-control"
                                    name="donation_category_id"
                                    value={formState.donation_category_id}
                                    onChange={handleChange}
                                  >
                                    {categoryData &&
                                      categoryData.map((item) => {
                                        return (
                                          <option value={item.value}>
                                            {item.label}
                                          </option>
                                        );
                                      })}
                                  </select>
                                  {errors.donation_category_id && (
                                    <small className="text-danger">
                                      {errors.donation_category_id}
                                    </small>
                                  )}
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group relatives">
                                  <label>Deadline</label>
                                  <DatePicker
                                    selected={formState.expiry_date}
                                    onChange={(date) => {
                                      console.log(date);
                                      setFormState({
                                        ...formState,
                                        expiry_date: date,
                                      });
                                    }}
                                    minDate={new Date()}
                                    ref={datepickerRef}
                                  />
                                  <img
                                    src="/images/calenders.png"
                                    alt="Calendar"
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "10px",
                                    }}
                                    onClick={() =>
                                      datepickerRef.current.setOpen(true)
                                    }
                                  />
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group" id="browsers">
                                  <label>Cover Image</label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    name="donation_images"
                                    ref={fileInputRef}
                                    onChange={(e) =>
                                      handleChange1(e, 0, "donation_images")
                                    }
                                  />
                                  <small>
                                    (Please upload an image with dimensions
                                    790*475 Pixels)
                                  </small>
                                  <br />
                                  {coverImageUploadStatus.uploading && (
                                    <ClipLoader
                                      color="#000"
                                      size={20}
                                      className="ml-2"
                                    />
                                  )}
                                  {coverImageUploadStatus.successMessage && (
                                    <small className="text-success">
                                      {coverImageUploadStatus.successMessage}
                                    </small>
                                  )}
                                  {errors.donation_images && (
                                    <small className="text-danger">
                                      {errors.donation_images}
                                    </small>
                                  )}
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div
                                  className="form-group flttr_adss_cam"
                                  id="add_more_filess"
                                >
                                  <div className="both_managess">
                                    <label>
                                      <span className="ad_btmss_ar">
                                        Gallery Image
                                      </span>
                                    </label>
                                    <div className="ad_buttons">
                                      <Link
                                        to="#"
                                        onClick={() => addMoreFields("gallery")}
                                      >
                                        + Add More
                                      </Link>
                                    </div>
                                  </div>

                                  {formState.other_images.map(
                                    (image, index) => (
                                      <div
                                        className="row add_mor_lisstst mt-0"
                                        key={index}
                                      >
                                        <div className="col-lg-10 col-sm-9 col-8">
                                          <div
                                            className="form-group mb-1"
                                            id="browsers"
                                          >
                                            <input
                                              type="file"
                                              className="form-control"
                                              ref={fileInputRef}
                                              onChange={(e) =>
                                                handleChange1(
                                                  e,
                                                  index,
                                                  "gallery"
                                                )
                                              }
                                            />
                                            <small>
                                              (Please upload an image with
                                              dimensions 790*475 Pixels)
                                            </small>
                                            <br />
                                            {galleryUploadStatus[index]
                                              ?.uploading && (
                                              <ClipLoader
                                                color="#000"
                                                size={20}
                                                className="ml-2"
                                              />
                                            )}
                                            {galleryUploadStatus[index]
                                              ?.successMessage && (
                                              <small className="text-success">
                                                {
                                                  galleryUploadStatus[index]
                                                    .successMessage
                                                }
                                              </small>
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-lg-2 col-sm-3 col-4">
                                          <div className="ad_buttons remove_bnt ad_compaing">
                                            <Link
                                              to="#"
                                              onClick={() =>
                                                removeField(index, "gallery")
                                              }
                                            >
                                              Remove
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>

                              <div className="col-lg-12">
                                <div
                                  className="form-group flttr_adss_cam"
                                  id="add_more_filess"
                                >
                                  <div className="both_managess">
                                    <label>
                                      <span className="ad_btmss_ar">
                                        Documents
                                      </span>
                                    </label>
                                    <div className="ad_buttons">
                                      <Link
                                        to="#"
                                        onClick={() =>
                                          addMoreFields("documents")
                                        }
                                      >
                                        + Add More
                                      </Link>
                                    </div>
                                  </div>

                                  {formState.documents.map((doc, index) => (
                                    <div
                                      className="row add_mor_lisstst mt-0"
                                      key={index}
                                    >
                                      <div className="col-lg-10 col-sm-9 col-8">
                                        <div
                                          className="form-group mb-1"
                                          id="browsers"
                                        >
                                          <input
                                            type="file"
                                            className="form-control"
                                            ref={fileInputRef}
                                            onChange={(e) =>
                                              handleChange1(
                                                e,
                                                index,
                                                "documents"
                                              )
                                            }
                                          />
                                          {documentUploadStatus[index]
                                            ?.uploading && (
                                            <ClipLoader
                                              color="#000"
                                              size={20}
                                              className="ml-2"
                                            />
                                          )}
                                          {documentUploadStatus[index]
                                            ?.successMessage && (
                                            <small className="text-success">
                                              {
                                                documentUploadStatus[index]
                                                  .successMessage
                                              }
                                            </small>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-lg-2 col-sm-3 col-4">
                                        <div className="ad_buttons remove_bnt ad_compaing">
                                          <Link
                                            to="#"
                                            onClick={() =>
                                              removeField(index, "documents")
                                            }
                                          >
                                            Remove
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-12 mt-4">
                            <div className="form-group">
                              <button
                                type="submit"
                                value="Publish Event"
                                className="sub_mitess"
                                disabled={buttonloader}
                              >
                                {buttonloader ? (
                                  <ClipLoader color="#fff" size={"25"} />
                                ) : (
                                  "Publish Campaign"
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AddCampaign;
